import { render, staticRenderFns } from "./menuRoled.vue?vue&type=template&id=dcd85364&"
import script from "./menuRoled.vue?vue&type=script&lang=js&"
export * from "./menuRoled.vue?vue&type=script&lang=js&"
import style0 from "./menuRoled.vue?vue&type=style&index=0&id=dcd85364&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports